import { get, post, apiPrefix } from './common';
import { webApiResponseHandler } from './api';
const getCompanyUDF = () => get(`${apiPrefix}/CompanyUDF`).then(webApiResponseHandler);
const saveCompanyUDF = (companyUDF) => post(`${apiPrefix}/CompanyUDF`, { ...companyUDF }).then(webApiResponseHandler);
export { getCompanyUDF, saveCompanyUDF };
